// GA strings need to have leading/trailing whitespace trimmed, and not all
// browsers have String.prototoype.trim().

function trim(s) {
  return s.replace(/^\s+|\s+$/g, '');
}

module.exports = trim;



//////////////////
// WEBPACK FOOTER
// ../~/react-ga/src/utils/trim.js
// module id = 498
// module chunks = 0